export const BarcodeIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 42 42"
    fill="none"
  >
    <g opacity="0.7" clipPath="url(#clip0_3793_21574)">
      <path
        d="M14.5621 19.6396V16.2796C14.5621 15.6796 14.0668 15.1996 13.4478 15.1996C12.8287 15.1996 12.3335 15.6796 12.3335 16.2796V19.7596H14.5621V19.6396Z"
        fill="#FFFFFF"
      />
      <path
        d="M12.3335 22.5198V26.8398C12.3335 27.4398 12.8287 27.9198 13.4478 27.9198C14.0668 27.9198 14.5621 27.4398 14.5621 26.8398V22.5198H12.3335Z"
        fill="#FFFFFF"
      />
      <path
        d="M17.7808 22.5198V26.2398C17.7808 27.0798 18.5236 27.7998 19.3903 27.7998C20.257 27.7998 20.9998 27.0798 20.9998 26.2398V22.5198H17.7808Z"
        fill="#FFFFFF"
      />
      <path
        d="M20.9998 19.6396V16.7596C20.9998 15.9196 20.257 15.1996 19.3903 15.1996C18.5236 15.1996 17.7808 15.9196 17.7808 16.7596V19.6396H20.9998Z"
        fill="#FFFFFF"
      />
      <path
        d="M27.5621 19.6396V16.2796C27.5621 15.6796 27.0668 15.1996 26.4478 15.1996C25.8287 15.1996 25.3335 15.6796 25.3335 16.2796V19.7596H27.5621V19.6396Z"
        fill="#FFFFFF"
      />
      <path
        d="M25.3335 22.5198V26.8398C25.3335 27.4398 25.8287 27.9198 26.4478 27.9198C27.0668 27.9198 27.5621 27.4398 27.5621 26.8398V22.5198H25.3335Z"
        fill="#FFFFFF"
      />
      <path
        d="M29.6672 19.6396V15.6796C29.6672 15.4396 29.4196 15.1996 29.172 15.1996C28.9244 15.1996 28.6768 15.4396 28.6768 15.6796V19.6396H29.6672Z"
        fill="#FFFFFF"
      />
      <path
        d="M28.5527 22.5198V27.3198C28.5527 27.5598 28.8004 27.7998 29.048 27.7998C29.2956 27.7998 29.5432 27.5598 29.5432 27.3198V22.5198H28.5527Z"
        fill="#FFFFFF"
      />
      <path
        d="M23.2288 19.6396V15.6796C23.2288 15.4396 22.9811 15.1996 22.7335 15.1996C22.4859 15.1996 22.2383 15.4396 22.2383 15.6796V19.6396H23.2288Z"
        fill="#FFFFFF"
      />
      <path
        d="M22.1143 22.5198V27.3198C22.1143 27.5598 22.3619 27.7998 22.6095 27.7998C22.8571 27.7998 23.1047 27.5598 23.1047 27.3198V22.5198H22.1143Z"
        fill="#FFFFFF"
      />
      <path
        d="M16.6672 19.6396V15.6796C16.6672 15.4396 16.4196 15.1996 16.172 15.1996C15.9244 15.1996 15.6768 15.4396 15.6768 15.6796V19.6396H16.6672Z"
        fill="#FFFFFF"
      />
      <path
        d="M15.5527 22.5198V27.3198C15.5527 27.5598 15.8004 27.7998 16.048 27.7998C16.4194 27.7998 16.667 27.5598 16.667 27.3198V22.5198H15.5527Z"
        fill="#FFFFFF"
      />
      <path
        d="M10.2286 14.1193V16.2793C10.2286 16.8793 9.73333 17.3593 9.11429 17.3593C8.49524 17.2393 8 16.8793 8 16.2793V13.1593C8 12.5593 8.24762 12.0793 8.61905 11.7193C8.99048 11.2393 9.60952 10.9993 10.2286 10.9993H13.4476C14.0667 10.9993 14.5619 11.4793 14.5619 12.0793C14.5619 12.6793 14.0667 13.1593 13.4476 13.1593H11.219C10.6 13.1593 10.2286 13.5193 10.2286 14.1193ZM31.7714 10.9993C32.3905 10.9993 32.8857 11.2393 33.2571 11.5993C33.7524 11.9593 34 12.5593 34 13.1593V16.2793C34 16.8793 33.5048 17.3593 32.8857 17.3593C32.2667 17.3593 31.7714 16.8793 31.7714 16.2793V14.1193C31.7714 13.5193 31.2762 13.0393 30.6571 13.0393H28.4286C27.8095 13.0393 27.3143 12.5593 27.3143 11.9593C27.3143 11.3593 27.8095 10.8793 28.4286 10.8793H31.7714V10.9993ZM10.2286 26.7193V28.8793C10.2286 29.4793 10.7238 29.9593 11.3429 29.9593H13.5714C14.1905 29.9593 14.6857 30.4393 14.6857 31.0393C14.6857 31.6393 14.1905 32.1193 13.5714 32.1193H10.2286C9.60952 32.1193 9.11429 31.8793 8.74286 31.5193C8.24762 31.0393 8 30.4393 8 29.9593V26.8393C8 26.2393 8.49524 25.7593 9.11429 25.7593C9.73333 25.6393 10.2286 26.1193 10.2286 26.7193ZM31.7714 28.8793V26.7193C31.7714 26.1193 32.2667 25.6393 32.8857 25.6393C33.5048 25.6393 34 26.1193 34 26.7193V29.8393C34 30.4393 33.7524 30.9193 33.381 31.2793C33.0095 31.6393 32.3905 31.8793 31.8952 31.8793H28.6762C28.0571 31.8793 27.5619 31.3993 27.5619 30.7993C27.5619 30.1993 28.0571 29.7193 28.6762 29.7193H30.9048C31.4 29.9593 31.7714 29.4793 31.7714 28.8793Z"
        fill="#FFFFFF"
      />
      <path
        d="M33.1339 21.4407H9.23862C9.11481 21.4407 8.86719 21.3207 8.86719 21.0807C8.86719 20.9607 8.991 20.7207 9.23862 20.7207H33.1339C33.2577 20.7207 33.5053 20.8407 33.5053 21.0807V21.2007C33.3815 21.3207 33.2577 21.4407 33.1339 21.4407Z"
        fill="#FFFFFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_3793_21574">
        <rect width="26" height="21" fill="white" transform="translate(8 11)" />
      </clipPath>
    </defs>
  </svg>
);
